import { render, staticRenderFns } from "./GroupSubjects.vue?vue&type=template&id=646b297d&"
import script from "./GroupSubjects.vue?vue&type=script&lang=js&"
export * from "./GroupSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports